module.exports = "/images/asientos.jpg?d31e4d58f98c939e9eefa28381a897e8";